module.exports = __webpack_public_path__ + "img/home_gongnue_icon.cb7086d8.png";